// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountControls_container__3QHK5","avatar":"AccountControls_avatar__XoVs_"};